import { render } from "./case-notice-day.vue?vue&type=template&id=357ed1b7&scoped=true"
import script from "./case-notice-day.vue?vue&type=script&lang=js"
export * from "./case-notice-day.vue?vue&type=script&lang=js"

import "./case-notice-day.vue?vue&type=style&index=0&id=357ed1b7&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357ed1b7"]])

export default __exports__